var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { formatListValue } from '@/shared/components/FormattedListValue';
import EnumCacheService from '@/shared/services/EnumCacheService';
import HasMultiCompany from '@/shared/components/security/HasMultiCompany';
import messages from '../generalSettingsMessages';
import TranslateListItemModal from '@/shared/components/translations/TranslateListItemModal';
var profileMessages = defineMessages({
    Responsible: { id: 'Responsible', defaultMessage: 'Responsible' },
    Assistant: { id: 'Assistant', defaultMessage: 'Assistant' },
    AssistantBackup: { id: 'AssistantBackup', defaultMessage: 'AssistantBackup' },
    Associate: { id: 'Associate', defaultMessage: 'Associate' },
    BillingUser: { id: 'BillingUser', defaultMessage: 'BillingUser' },
    SeniorUser: { id: 'SeniorUser', defaultMessage: 'SeniorUser' },
});
var PROFILE_MESSAGE_MAP = {
    1: 'Responsible',
    2: 'Assistant',
    3: 'AssistantBackup',
    4: 'Associate',
    5: 'BillingUser',
    6: 'SeniorUser',
};
var EmployeeProfileTranslationsSection = function (_a) {
    var canUpdate = _a.canUpdate;
    var intl = useIntl();
    var _b = useState([]), employeeProfiles = _b[0], setEmployeeProfiles = _b[1];
    var _c = useState(null), translateProfile = _c[0], setTranslateProfile = _c[1];
    useEffect(function () {
        EnumCacheService.get('employeeprofile').then(function (data) {
            setEmployeeProfiles((data || []).sort(dynamicSort('key')));
        });
    }, []);
    var getDefaultTranslation = function (profileKey) {
        var msgKey = PROFILE_MESSAGE_MAP[profileKey];
        if (!msgKey)
            return '';
        return intl.formatMessage(profileMessages[msgKey]);
    };
    return (_jsxs("div", __assign({ className: "control-panel subsection" }, { children: [_jsxs("div", __assign({ className: "title-block" }, { children: [_jsx("span", { children: intl.formatMessage(messages.EmployeeProfileTranslations) }), _jsx(HasMultiCompany, { children: _jsx("i", { className: "fa fa-fw fa-globe text-muted", title: intl.formatMessage(messages.ThisSettingIsAppliedToAllOwnCompanies) }) })] })), _jsx("div", __assign({ className: "panel-body container-fluid" }, { children: employeeProfiles.map(function (profile) { return (_jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-md-5" }, { children: _jsx("label", { children: getDefaultTranslation(profile.key) }) })), _jsx("div", __assign({ className: "col-md-7" }, { children: canUpdate ? (_jsx("a", __assign({ className: "form-control-static clickable bold", onClick: function () { return setTranslateProfile(profile); }, style: { cursor: 'pointer' } }, { children: _jsx("span", { children: formatListValue({
                                        list: 'employeeprofile',
                                        id: profile.key,
                                        fallback: getDefaultTranslation(profile.key),
                                        intl: intl,
                                    }) }) }))) : (_jsx("p", __assign({ className: "form-control-static" }, { children: formatListValue({
                                    list: 'employeeprofile',
                                    id: profile.key,
                                    fallback: getDefaultTranslation(profile.key),
                                    intl: intl,
                                }) }))) }))] }), profile.key)); }) })), translateProfile && (_jsx(TranslateListItemModal, { list: "employeeprofile", listId: String(translateProfile.key), fallback: getDefaultTranslation(translateProfile.key), show: !!translateProfile, onClose: function () { return setTranslateProfile(null); }, defaultRequired: false, maxLength: 250 }))] })));
};
export default EmployeeProfileTranslationsSection;
